export default "__VITE_IMAGE_ASSET__dbb91db7__";